export default __webpack_public_path__ + "static/media/TutorialSVG.101529dc.svg";